var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { "courses-section": true, mobile: _vm.isMobile(_vm.$mq) } },
    [
      _c("h2", [_vm._v("What can they learn on Brilliant?")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "categories" },
        _vm._l(_vm.splitCoursesByCategory, function(courses, category) {
          return _c(
            "div",
            { key: category, staticClass: "category" },
            [
              _c("h3", [_vm._v(_vm._s(category))]),
              _vm._v(" "),
              _c(
                "ul",
                _vm._l(courses.head, function(course) {
                  return _c(
                    "li",
                    { key: course.slug },
                    [
                      _c("BriocheImageTag", {
                        staticClass: "img",
                        attrs: {
                          src: course.intro_image_url,
                          width: 20,
                          alt: course.name
                        }
                      }),
                      _vm._v(
                        "\n          " + _vm._s(course.name) + "\n        "
                      )
                    ],
                    1
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "transition",
                { attrs: { name: "fade-fast", mode: "out-in" } },
                [
                  courses.tail.length && !_vm.showTailForCategory[category]
                    ? _c(
                        "button",
                        {
                          staticClass: "view-more",
                          on: {
                            click: function($event) {
                              return _vm.handleShowTail(category)
                            }
                          }
                        },
                        [_vm._v("\n          View more ▼\n        ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  courses.tail.length && _vm.showTailForCategory[category]
                    ? _c(
                        "ul",
                        _vm._l(courses.tail, function(course) {
                          return _c(
                            "li",
                            { key: course.slug },
                            [
                              _c("BriocheImageTag", {
                                staticClass: "img",
                                attrs: {
                                  src: course.intro_image_url,
                                  width: 20,
                                  alt: course.name
                                }
                              }),
                              _vm._v(
                                "\n            " +
                                  _vm._s(course.name) +
                                  "\n          "
                              )
                            ],
                            1
                          )
                        }),
                        0
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }